import {
  clearEncryptedStorage,
  flushPendingPlainStorageKeyMigration,
  readEncryptedStorageItem,
  removeEncryptedStorageItem,
  writeEncryptedStorageItem,
} from './local-storage-encryption.util';
import { registerLocalStorageEncryptionKeyReadyHandler } from './local-storage-key-state.util';
import {
  getNativeLocalStorage,
  getNativeSessionStorage,
  migrateAllPlainLocalStorageKeys,
} from './local-storage-native.util';

function handleEncryptionKeyReady(): void {
  migrateAllPlainLocalStorageKeys();
  flushPendingPlainStorageKeyMigration(
    getNativeLocalStorage(),
    getNativeSessionStorage()
  );
}

function patchStorage(storage: Storage, kind: 'local' | 'session'): void {
  const native =
    storage === window.localStorage
      ? getNativeLocalStorage()
      : getNativeSessionStorage();

  storage.getItem = (key: string): string | null =>
    readEncryptedStorageItem(native, kind, key);

  storage.setItem = (key: string, value: string): void =>
    writeEncryptedStorageItem(native, kind, key, value);

  storage.removeItem = (key: string): void =>
    removeEncryptedStorageItem(native, kind, key);

  storage.clear = (): void => clearEncryptedStorage(native);
}

let shimInstalled = false;

/** Install encrypt/decrypt layer on localStorage and sessionStorage before Angular boot. */
export function installLocalStorageEncryptionShim(): void {
  if (shimInstalled || typeof window === 'undefined') {
    return;
  }

  registerLocalStorageEncryptionKeyReadyHandler(handleEncryptionKeyReady);
  patchStorage(window.localStorage, 'local');
  patchStorage(window.sessionStorage, 'session');
  shimInstalled = true;
}
